import { Component, Input } from '@angular/core';
import { result } from 'lodash-es';
import { CommunicationService } from 'src/app/communication/shared/communication.service';
import { MemberEmailEngagementSearchDto } from 'src/app/communication/shared/member-email-engagement-search.dto';
import { MemberEmailEngagementSearchResultDto } from 'src/app/communication/shared/member-email-engagement-search-result.dto';
import { DatagridService, PagedResultGeneric } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';

@Component({
  selector: 'wl-member-email-engagement-grid',
  templateUrl: './member-email-engagement-grid.component.html',
  styleUrl: './member-email-engagement-grid.component.less',
    standalone: false
})
export class MemberEmailEngagementGridComponent extends LazySelectableTableComponent<
  MemberEmailEngagementSearchDto,
  MemberEmailEngagementSearchResultDto
> {
  @Input() startDate: Date;
  @Input() endDate: Date;

  public constructor(
    private _communicationService: CommunicationService,
    private _navigationService: NavigationService,
    datagridService: DatagridService
  ) {
    super('', datagridService);
    this.searchParams = {
      PageNumber: 1,
      PageSize: 5,
    } as MemberEmailEngagementSearchDto;
  }

  fetchResults(): Promise<PagedResultGeneric<MemberEmailEngagementSearchResultDto>> {
    return this._communicationService.getTopFiveMembersByEmailEngagement(this.searchParams).then((result) => {
      return {
        Result: result,
        PageSize: 5,
        TotalPages: 1,
        CurrentPageNumber: 1,
      } as PagedResultGeneric<MemberEmailEngagementSearchResultDto>;
    });
  }

  navigateToProfile(profileId: number) {
    this._navigationService.navigateToProfileView(profileId);
  }
}
